import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const financeRecordItemsWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.record.items",
  name: "Posted journal items",
  description: "Posted journal items for the selected dashboard period.",
  apps: [
    "finance",
    "configuration",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "finance.posted-journal-items",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "journal_item_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Posted items",
    subtext: "",
    icon: "orders",
    color: "purple",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 0,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
